export default "__VITE_ASSET__CGOfKnwR__"